import { Widget } from '@factorialco/f0-react/dist/experimental'
import { isEmpty } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import DropItem, { UploadFile } from 'modules/expenses/components/common/DropItem'
import { useFilesPreviewer } from 'modules/expenses/components/expenses/Detail/hooks/useFilesPreviewer'
import { SignableOrganizationPerCountry } from 'modules/expenses/hooks/useTaxAgencyHomologations'
import { Expensable } from 'modules/expenses/types/Expensable'

interface AttachedDocumentsWidgetProps {
  expensable: Expensable
  editable: boolean
  onEdit: () => void
  adeTermsAccepted?: boolean
  taxAgencyOrganization?: SignableOrganizationPerCountry | null
}

const AttachedDocumentsWidget = ({
  expensable,
  adeTermsAccepted,
  taxAgencyOrganization,
}: AttachedDocumentsWidgetProps) => {
  const previewer = useFilesPreviewer()
  const signedDocument = expensable?.expense?.signedDocument
  const originalSigningFiles = signedDocument?.originalFiles

  const reporterCountry = expensable?.reporter?.legalEntity?.country
  const isItalyTaxAgency =
    reporterCountry === 'it' && taxAgencyOrganization === 'ade' && adeTermsAccepted === true
  const adeArchived = expensable?.expense?.adeArchived

  if (isEmpty(previewer.files)) {
    return null
  }

  return (
    <Widget
      header={{
        title: i18n.t('expenses_v2.confirmation_screen.expense.attached_documents_block.title'),
      }}
    >
      {previewer.files.map((file: UploadFile) => (
        <DropItem
          key={file.id || file.name + file.size}
          file={file}
          onSelectFileForViewer={previewer.selectFile}
          showAdeTag={isItalyTaxAgency}
          adeArchived={adeArchived}
          signedDocument={Number(file.id) === signedDocument?.file?.id}
          signingDocument={originalSigningFiles?.some(
            (originalFile) => String(originalFile.id) === String(file.id)
          )}
        />
      ))}
    </Widget>
  )
}

export default AttachedDocumentsWidget
